/**This section has all the constants to be used for the application. */
export const Constants = {
    apiKey:'x-api-key',
    ssoToken: 'ssotoken',
    authorization:'Authorization',
    defaultRoute:'dashboard',
    adminRole:'ADMIN',
    financeRole:'FINANCE',
    GICActivities:'GIC Activities',
    GICManualActivities:'GICManual Activities',
    AccessController:'Access Controller',
    MappingConfiguration:'Mapping Configuration',
    accessDenied:'Access Denied'
}
export enum ACEEnums {
    TerritoryBudgets='TerritoryBudgets',
    DetailedUpload='DetailedUpload',
    FinalQuotaList='FinalQuotaList',
    QuotaInput='QuotaInput',
    QuotaInputGic='QuotaInputGic',
    QuotaInputManualGic='QuotaInputManualGic',
    Upload='Upload',
    UploadManualRequests='UploadManualRequests',
    UploadManual='UploadManual',
    UploadRequests='UploadRequests',
    DownloadTemplate='DownloadTemplate',
    DownloadManualTemplate='DownloadManualTemplate',
    AccessController ='AccessController',
    EditAccess='EditAccess',
    ArchivefileList ='ArchivefileList',
    RolePlanTypeMapping='RolePlanTypeMapping',
    AddRolePlanTypeMapping='AddRolePlanTypeMapping',
    EditRolePlanTypeMapping='EditRolePlanTypeMapping',
    RolePayCurveMapping='RolePayCurveMapping',
    AddRolePayCurveMapping='AddRolePayCurveMapping',
    EditRolePayCurveMapping='EditRolePayCurveMapping'

}

